import React, { useEffect, useCallback } from 'react';

export default function MediaModal({ url, type, onClose }) {
  const handleKeyDown = useCallback(
    e => {
      if (e.keyCode === 27) onClose();
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  if (!url) return null;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.85)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        cursor: 'zoom-out',
      }}
    >
      <button
        type="button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          borderRadius: '50%',
          width: 36,
          height: 36,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          color: '#fff',
          fontSize: '18px',
        }}
      >
        ✕
      </button>

      <div
        onClick={e => e.stopPropagation()}
        role="presentation"
        style={{ maxWidth: '90vw', maxHeight: '90vh' }}
      >
        {type === 'video' ? (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video
            src={url}
            controls
            autoPlay
            style={{
              maxWidth: '90vw',
              maxHeight: '85vh',
              borderRadius: '8px',
            }}
          />
        ) : (
          <img
            src={url}
            alt="Mídia"
            style={{
              maxWidth: '90vw',
              maxHeight: '85vh',
              borderRadius: '8px',
              objectFit: 'contain',
            }}
          />
        )}
      </div>
    </div>
  );
}
